import { PortableTextBlock, PortableTextChild } from '@sanity/types';

const blocksToText = (blocks: PortableTextBlock): string => {
  if (!Array.isArray(blocks)) {
    return ''; // Ensure blocks is an array before proceeding
  }

  return blocks
    .map((block) => {
      if (block._type !== 'block' || !block.children || !Array.isArray(block.children)) {
        return ''; // Remove non-text blocks by returning an empty string
      }

      return block.children
        .map((child: PortableTextChild) => {
          if (child._type === 'span') {
            return child.text;
          }
          return ''; // Ignore non-text child types
        })
        .join('');
    })
    .join('\n\n'); // Separate blocks by double newlines
};

export default blocksToText;
